document.addEventListener('DOMContentLoaded', function () {
  initSgReveal();
  initSgGaleria();
  initSgVariantes();
  initSgMarquee();
  initSgCifras();
});

function initSgMarquee() {
  var pistas = document.querySelectorAll('[data-sg-marquee-pista]');
  pistas.forEach(function (pista) {
    if (pista.getAttribute('data-sg-duplicada')) return;
    pista.innerHTML += pista.innerHTML;
    pista.setAttribute('data-sg-duplicada', '1');
    var segundos = pista.getAttribute('data-sg-duracion') || '28';
    pista.style.animationDuration = segundos + 's';
  });
}

function initSgCifras() {
  var cifras = document.querySelectorAll('[data-sg-cifra]');
  if (!cifras.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-sg-cifra'));
        if (isNaN(fin)) return;
        var sufijo = el.getAttribute('data-sg-sufijo') || '';
        var duracion = 1400;
        var inicioTiempo = null;
        function paso(t) {
          if (!inicioTiempo) inicioTiempo = t;
          var progreso = Math.min((t - inicioTiempo) / duracion, 1);
          var actual = Math.floor(progreso * fin);
          el.textContent = actual.toLocaleString('es-CL') + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = fin.toLocaleString('es-CL') + sufijo;
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  cifras.forEach(function (el) { observer.observe(el); });
}

function initSgReveal() {
  var els = document.querySelectorAll('.sg-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('sg-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sg-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el, i) {
    el.style.transitionDelay = (i % 6) * 80 + 'ms';
    observer.observe(el);
  });
}

function initSgGaleria() {
  var galeria = document.querySelector('[data-sg-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-sg-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-sg-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      minis.forEach(function (m) { m.classList.remove('is-activa'); });
      mini.classList.add('is-activa');
    });
  });
}

function initSgVariantes() {
  var formularios = document.querySelectorAll('[data-sg-producto]');
  formularios.forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-sg-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var opciones = wrap.querySelectorAll('.sg-opcion');
    var inputId = wrap.querySelector('[data-sg-input-id]');
    var precioActual = wrap.querySelector('[data-sg-precio-actual]');
    var precioAnterior = wrap.querySelector('[data-sg-precio-anterior]');
    var botonComprar = wrap.querySelector('[data-sg-boton-comprar]');
    var stockAviso = wrap.querySelector('[data-sg-stock-aviso]');

    function moneyFmt(cents) {
      return '$' + (cents / 100).toLocaleString('es-CL', { minimumFractionDigits: 0 });
    }

    function seleccionar(opcion) {
      opciones.forEach(function (o) { o.classList.remove('is-seleccionada'); });
      opcion.classList.add('is-seleccionada');
      var variantId = opcion.getAttribute('data-variant-id');
      var variante = variantes.filter(function (v) { return String(v.id) === String(variantId); })[0];
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioActual) precioActual.textContent = moneyFmt(variante.price);
      if (precioAnterior) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnterior.textContent = moneyFmt(variante.compare_at_price);
          precioAnterior.style.display = '';
        } else {
          precioAnterior.style.display = 'none';
        }
      }
      if (botonComprar) botonComprar.disabled = !variante.available;
      if (stockAviso) {
        if (!variante.available) {
          stockAviso.textContent = 'Sin stock en esta talla';
          stockAviso.classList.add('is-agotado');
        } else {
          stockAviso.textContent = 'Disponible para envio';
          stockAviso.classList.remove('is-agotado');
        }
      }
    }

    opciones.forEach(function (opcion) {
      if (opcion.classList.contains('is-agotada')) return;
      opcion.addEventListener('click', function () { seleccionar(opcion); });
    });
  });
}
